import { render } from "./LegalConsent.vue?vue&type=template&id=5df14c8e&scoped=true"
import script from "./LegalConsent.vue?vue&type=script&lang=js"
export * from "./LegalConsent.vue?vue&type=script&lang=js"

import "./LegalConsent.vue?vue&type=style&index=0&id=5df14c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df14c8e"]])

export default __exports__